var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticStyle: { "min-width": "1200px" } },
    [
      _c(
        "el-container",
        [
          _c("el-header", [_c("topnav")], 1),
          _vm._v(" "),
          _c("el-main", [_vm.routerAlive ? _c("router-view") : _vm._e()], 1),
          _vm._v(" "),
          _c("el-footer", [_c("footernav")], 1)
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "fixedRightNav" },
        [
          _c(
            "div",
            { staticClass: "rightNav" },
            [
              this.userInfo.mallUser.username
                ? _c("img", {
                    staticClass: "ai_agent_icon",
                    attrs: { src: require("../assets/img/ai_agent.png") },
                    on: {
                      click: function($event) {
                        return _vm.goAiagent()
                      }
                    }
                  })
                : _vm._e(),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "rightButton backTop",
                  on: { click: _vm.backTop }
                },
                [
                  _c("el-image", {
                    staticStyle: { width: "20px", height: "20px" },
                    attrs: {
                      src: _vm.$imageUrl + "/pcImages/images/backTop.png",
                      fit: "fill"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "transition",
                { attrs: { name: "el-fade-in-linear" } },
                [
                  _c(
                    "el-popover",
                    {
                      attrs: {
                        placement: "left-end",
                        width: "300",
                        trigger: "click"
                      },
                      on: { show: _vm.refreshUser }
                    },
                    [
                      _c(
                        "div",
                        [
                          _c(
                            "el-row",
                            {
                              staticClass: "userNameBox",
                              attrs: { gutter: 20 }
                            },
                            [
                              _c(
                                "el-col",
                                { attrs: { span: 9 } },
                                [
                                  _c(
                                    "el-image",
                                    {
                                      staticClass: "userNameImg",
                                      attrs: {
                                        src: _vm.userInfo.avatar
                                          ? _vm.userInfo.avatar
                                          : _vm.defaultlogo,
                                        fit: "fill"
                                      }
                                    },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass: "image-slot",
                                          attrs: { slot: "error" },
                                          slot: "error"
                                        },
                                        [
                                          _c("i", {
                                            staticClass:
                                              "el-icon-picture-outline"
                                          })
                                        ]
                                      )
                                    ]
                                  )
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "el-col",
                                {
                                  staticClass: "userNameBoxText",
                                  attrs: { span: 14 }
                                },
                                [
                                  _c("p", { staticClass: "userName" }, [
                                    _vm._v(
                                      "用户：" + _vm._s(_vm.userInfo.userName)
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "p",
                                    {
                                      staticClass: "level",
                                      staticStyle: { display: "none" }
                                    },
                                    [
                                      _vm._v(
                                        "等级：" +
                                          _vm._s(_vm.userInfo.level || 0)
                                      )
                                    ]
                                  )
                                ]
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c("el-divider"),
                          _vm._v(" "),
                          _c(
                            "el-row",
                            { staticClass: "cartBox_footer" },
                            [
                              _c(
                                "el-col",
                                {
                                  staticClass: "userNameBoxBottom",
                                  attrs: { span: 12 }
                                },
                                [
                                  _c(
                                    "router-link",
                                    { attrs: { to: "/myInfomation" } },
                                    [_vm._v("个人中心")]
                                  )
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "el-col",
                                {
                                  staticClass: "userNameBoxBottom",
                                  attrs: { span: 12 }
                                },
                                [
                                  _c(
                                    "router-link",
                                    { attrs: { to: "/myOrderRight" } },
                                    [_vm._v("订单中心")]
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-button",
                        { attrs: { slot: "reference" }, slot: "reference" },
                        [
                          this.userInfo.mallUser.username == null ||
                          "" ||
                          undefined
                            ? _c(
                                "div",
                                {
                                  staticClass: "rightButton",
                                  on: {
                                    click: [
                                      function($event) {
                                        $event.stopPropagation()
                                        return _vm.doSomething($event)
                                      },
                                      function($event) {
                                        return _vm.gologin()
                                      }
                                    ]
                                  }
                                },
                                [
                                  _c("el-image", {
                                    staticStyle: {
                                      width: "20px",
                                      height: "20px"
                                    },
                                    attrs: {
                                      src:
                                        _vm.$imageUrl +
                                        "/pcImages/images/userIcon.png",
                                      fit: "fill"
                                    }
                                  })
                                ],
                                1
                              )
                            : _c(
                                "div",
                                { staticClass: "rightButton" },
                                [
                                  _c("el-image", {
                                    staticStyle: {
                                      width: "20px",
                                      height: "20px"
                                    },
                                    attrs: {
                                      src:
                                        _vm.$imageUrl +
                                        "/pcImages/images/userIcon.png",
                                      fit: "fill"
                                    }
                                  })
                                ],
                                1
                              )
                        ]
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c("div", { staticClass: "interlayer" }),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "rightButton shoppingCart",
                  on: { click: _vm.openCartDrawer }
                },
                [
                  _c("el-image", {
                    staticStyle: { width: "20px", height: "20px" },
                    attrs: {
                      src: _vm.$imageUrl + "/pcImages/images/shopCardIcon.png",
                      fit: "fill"
                    }
                  }),
                  _vm._v(" "),
                  _vm.list.length > 0
                    ? _c("i", { staticClass: "shopping-cart-num" }, [
                        _vm._v(_vm._s(_vm.list.length))
                      ])
                    : _vm._e()
                ],
                1
              ),
              _vm._v(" "),
              false ? _c("div", { staticClass: "interlayer" }) : _vm._e(),
              _vm._v(" "),
              false
                ? _c(
                    "div",
                    {
                      staticClass: "rightButton shoppingCart",
                      on: { click: _vm.openInquiry }
                    },
                    [
                      _c("el-image", {
                        staticStyle: { width: "20px", height: "20px" },
                        attrs: {
                          src:
                            _vm.$imageUrl +
                            "/pcImages/images/xunjialanIcon.png",
                          fit: "fill"
                        }
                      }),
                      _vm._v(" "),
                      _vm.inquiryList.length > 0
                        ? _c("i", { staticClass: "shopping-cart-num" }, [
                            _vm._v(_vm._s(_vm.inquiryList.length))
                          ])
                        : _vm._e()
                    ],
                    1
                  )
                : _vm._e()
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-drawer",
            {
              staticClass: "drawerCart",
              attrs: {
                title: "购物车",
                modal: false,
                visible: _vm.footerdrawer
              },
              on: {
                "update:visible": function($event) {
                  _vm.footerdrawer = $event
                }
              }
            },
            [
              _c(
                "p",
                {
                  staticClass: "drawerCartTitle",
                  attrs: { slot: "title" },
                  slot: "title"
                },
                [
                  _c("i", { staticClass: "el-icon-view" }),
                  _vm._v(" "),
                  _c(
                    "router-link",
                    { staticClass: "gotoShopText", attrs: { to: "/myFooter" } },
                    [_vm._v("我的足迹")]
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "loading",
                      rawName: "v-loading",
                      value: _vm.footloading,
                      expression: "footloading"
                    }
                  ],
                  staticClass: "drawerCartItem drawerFooterItem"
                },
                [
                  _vm._l(_vm.footerlist, function(item, index) {
                    return _c(
                      "div",
                      { key: index, staticClass: "isdrawerFooterItem" },
                      [
                        item.commodity != null
                          ? _c(
                              "div",
                              { staticClass: "isdrawerFooterItemBg" },
                              [
                                _c(
                                  "el-image",
                                  {
                                    staticClass: "goodsFooter",
                                    staticStyle: { cursor: "pointer" },
                                    attrs: {
                                      src: "" + item.commodity.photos,
                                      fit: "fill"
                                    },
                                    on: {
                                      click: function($event) {
                                        return _vm.$jumpUrl(
                                          "/goodsdetail",
                                          item.commodity.id
                                        )
                                      }
                                    }
                                  },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticClass: "image-slot",
                                        attrs: { slot: "error" },
                                        slot: "error"
                                      },
                                      [
                                        _c("i", {
                                          staticClass: "el-icon-picture-outline"
                                        })
                                      ]
                                    )
                                  ]
                                ),
                                _vm._v(" "),
                                _c("div", { staticClass: "cartHeight" }, [
                                  _vm._v(
                                    "￥" + _vm._s(item.commodity.realprice)
                                  )
                                ])
                              ],
                              1
                            )
                          : _vm._e()
                      ]
                    )
                  }),
                  _vm._v(" "),
                  (_vm.footerlist.length == 0
                  ? true
                  : false)
                    ? _c(
                        "div",
                        { staticClass: "drawerCartItem_no" },
                        [
                          _c(
                            "el-image",
                            {
                              staticStyle: { cursor: "pointer" },
                              attrs: {
                                src: require("@/assets/img/noresult.png"),
                                fit: "fill"
                              }
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass: "image-slot",
                                  attrs: { slot: "error" },
                                  slot: "error"
                                },
                                [
                                  _c("i", {
                                    staticClass: "el-icon-picture-outline"
                                  })
                                ]
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c("p", [_vm._v("暂无您的浏览记录")]),
                          _vm._v(" "),
                          _c(
                            "router-link",
                            {
                              staticClass: "gotoShopText",
                              attrs: { to: "/goodsList" }
                            },
                            [_vm._v("再去看看吧")]
                          )
                        ],
                        1
                      )
                    : _vm._e()
                ],
                2
              )
            ]
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          staticClass: "dialogIMBox",
          attrs: {
            title: "提示",
            visible: _vm.centerDialogVisible,
            modal: _vm.b_modal,
            width: "35%",
            "append-to-body": _vm.bodyflag,
            center: ""
          },
          on: {
            "update:visible": function($event) {
              _vm.centerDialogVisible = $event
            }
          }
        },
        [
          _c("span", {
            staticClass: "dialog-footer",
            attrs: { slot: "title" },
            slot: "title"
          }),
          _vm._v(" "),
          _c("div", { staticClass: "row1", attrs: { id: "content-main-1" } }, [
            _c("iframe", {
              attrs: {
                id: "myiframe",
                onload: "setIframeHeight(this)",
                src: "http://8.136.244.109:8080/center/IM/#/main",
                width: "100%",
                height: "100%",
                frameborder: "0",
                seamless: "",
                scrolling: "no"
              }
            })
          ])
        ]
      ),
      _vm._v(" "),
      _c(
        "el-drawer",
        {
          staticClass: "drawerCart",
          attrs: {
            title: "Ai问答",
            size: "100%",
            modal: true,
            visible: _vm.footerdrawer,
            "append-to-body": true
          },
          on: {
            "update:visible": function($event) {
              _vm.footerdrawer = $event
            }
          }
        },
        [_c("aiagentBox", { on: { closeDrawer: _vm.closeDrawer } })],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-a83bd3b0", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a83bd3b0","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/index.vue
// module id = KYHG
// module chunks = 129